<template>
	<el-tabs id="userinfoList" value="first" type="border-card">
		<el-tab-pane name="first" :label="$t('subtaskInfo')">
			<el-row>
				<el-col :xs="24">
          <el-form :model="subtaskForm" :rules="rules" ref="subtaskForm" label-width="210px">
					  <el-card >
              <el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskName1')" prop="taskName">
                    <el-input v-model="subtaskForm.taskName" v-if="editDis == 1" disabled/>
                    <el-input v-model="subtaskForm.taskName" v-if="editDis == 0" @click.native="selectTask"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskType1')" >
                    <el-input v-model="subtaskForm.taskType" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subtaskName1')" prop="subtaskName">
										<el-input v-model="subtaskForm.subtaskName" clearable :placeholder="$t('enter')" />
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12" style="display: flex">
                  <div style="width: 294px">
                    <el-form-item label="Actual Delivery:" prop="quantityMark" class="isEngineerGroupItem">
                      <el-select v-model="subtaskForm.quantityMark" @change="changeIsEngineerGroup">
                        <el-option :key="0" label="Engineer" :value="0"></el-option>
                        <el-option :key="1" label="Group" :value="1"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div :style="{ 'display': subtaskForm.quantityMark === 0 ? '' : 'none', 'width': '187px'}">
                    <el-form-item label="" prop="actualDeliveryEngineer" label-width="0" class="engineerGroupItem" style="width: 187px">
                      <el-select v-model="subtaskForm.actualDeliveryEngineer" clearable filterable multiple remote :remote-method="remoteMethod">
                        <el-option v-for="(item) in SubtaskOwnerList" :key="item.userCode" :label="item.userCode" :value="item.userCode"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>

                  <div :style="{ 'display': subtaskForm.quantityMark === 1 ? '' : 'none', 'width': '187px'}">
                    <el-form-item label="" prop="groupId" label-width="0" class="engineerGroupItem groupItem" style="width: 187px">
                      <el-select v-model="subtaskForm.groupId" clearable filterable>
                        <el-option v-for="(item) in groupData" :key="item.id" :label="item.sysValue" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subtaskStatus1')" prop="subtaskStatus" >
                    <el-select v-model="subtaskForm.subtaskStatus" clearable>
											<el-option v-for="item in StatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('totalPlannedHour1')" prop="plannedLabourHour">
                    <el-input v-model="subtaskForm.plannedLabourHour" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceStartDate1')" prop="serviceStartDate">
                    <el-date-picker v-model="subtaskForm.serviceStartDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceEndDate1')" prop="serviceEndDate">
                    <el-date-picker v-model="subtaskForm.serviceEndDate" disabled :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row v-if="showLeave">
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryEngineerCity1')">
                    <el-input v-model="subtaskForm.deliveryEngineerCity" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryAddress1')" >
                    <el-input v-model="subtaskForm.deliveryAddress" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
              </el-row>
							<!-- <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subtaskEstimatedStartDate1')" prop="subtaskEstimatedStartDate">
										<el-date-picker v-model="subtaskForm.subtaskEstimatedStartDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subtaskEstimatedEndDate1')" prop="subtaskEstimatedEndDate">
										<el-date-picker v-model="subtaskForm.subtaskEstimatedEndDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
              </el-row> -->
              <!-- <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('plannedDate1')" prop="plannedDate">
										<el-date-picker v-model="subtaskForm.plannedDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryFinishedDate1')" prop="deliveryFinishedDate">
										<el-date-picker v-model="subtaskForm.deliveryFinishedDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
							</el-row> -->
							<el-row v-if="showLeave">
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('isStationin1')" >
                    <el-select v-model="subtaskForm.isStationin" clearable>
											<el-option v-for="item in IsStationinList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('subtaskReport1')"  >
                    <el-upload action="" :accept="acceptFileType" :before-upload="beforeUpload" 
                      :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" :auto-upload="true" >
                      <el-button slot="trigger" size="small" type="primary">{{$t('upload')}}</el-button>
                    </el-upload>
                  </el-form-item>
                </el-col>
							</el-row>
              <el-row>
                <el-col style="margin-top: 10px; text-align: center;" :xs="24" :md="24">
                  <el-button type="primary" @click="submitForm('subtaskForm')">{{$t('save')}}</el-button>
                  <el-button type="primary" @click="continueForm('subtaskForm')">{{$t('save_continue')}}</el-button>
                  <el-button type="primary" size="medium" @click="returnList">{{$t('return')}}</el-button>
                </el-col>
              </el-row>
            </el-card>
          </el-form>
          <Modal v-model="modelSearch" width="60%" id="modelSearch" :closable='true' :mask-closable='false' :title="$t('Select Task')">
            <div slot="footer"></div>
            <!-- 查询选项 -->
            <Form class="modelForm" :label-width="160">
              <FormItem class="modelItem" :label="$t('taskName1')">
                <Input v-model="tkName" clearable :placeholder="$t('enter')"/>
              </FormItem>
              <FormItem class="modelItem" :label="$t('taskStartDate1')" >
                <el-date-picker v-model="tkStartDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
              </FormItem>
              <FormItem class="modelItem" :label="$t('taskEndDate1')" >
                <el-date-picker v-model="tkEndDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
              </FormItem>
              <FormItem class="modelItem" :label="$t('taskType1')">
                <el-select v-model="tkType" clearable>
                  <el-option v-for="item in TaskTypeList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem class="modelItem" :label="$t('taskOwner1')">
                <Input v-model="tkOwner" clearable :placeholder="$t('enter')"/>
              </FormItem>
              <div class="buttonDiv">
                <el-button type="primary" size="mini" icon="el-icon-search" @click="searchTaskList">{{$t('search')}}</el-button>
              </div>
            </Form>
            <el-table :data="TSList" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
              <el-table-column prop="taskName" :label="$t('taskName')" align="center" min-width="300" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                <a style="color:blue;" @click="handleInfo(scope.row)">{{scope.row.taskName}}</a>
              </template>
              </el-table-column>
              <el-table-column prop="taskStartDate" :label="$t('taskStartDate')" align="center" min-width="155" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="taskEndDate" :label="$t('taskEndDate')" align="center" min-width="155" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="taskType" :label="$t('taskType')" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="taskOwner" :label="$t('taskOwner')" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
            <div class="pageDiv">
              <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[5,10,30,50]"
                :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
              </el-pagination>
            </div>
          </Modal>
				</el-col>
			</el-row>
		</el-tab-pane>
	</el-tabs>
</template>


<script>
    import {_debounce} from '@/utils/selectAPI'
    import * as validate from '@/utils/validate'
    export default {
        created () {
          this.getTaskTypeList();
          this.getTaskList();
          this.getGroupList();
        },
        data () {
          var checkHours = (rule, value, callback) => {
            let index = rule.field.split(".")[1];
            let reg = /^\d+(\.\d{0,2})?$/;
            if(!reg.test(value)){
              return callback(new Error('Please enter integer or decimal to two places'));
            }else if(value < 0.01 || value > 9999){
              return callback(new Error('Please enter 0.01--9999.00'));
            }
            callback();
          };
          return {
            rangeNumber: 10,
            subtaskForm: {
              projectId:null,
              taskId:null,
              taskName:null,
              taskType:null,
              subtaskName:null,
              subtaskStatus:null,
              plannedLabourHour:null,
              quantityMark: 0,
              actualDeliveryEngineer:[],
              groupId:null,
              deliveryEngineerCity:null,
              deliveryAddress:null,
              subtaskEstimatedStartDate:null,
              subtaskEstimatedEndDate:null,
              serviceStartDate:null,
              serviceEndDate:null,
              plannedDate:null,
              deliveryFinishedDate:null,
              isStationin:null,
              subtaskReport:null,
            },
            subForm:{},
            editDis:0,
            reportArr:[],
            fileList:[],
            acceptFileType:'.bpm,.gif,.jpg,.jpeg,.png,.pdf,.xls,.xlsx,.doc,.docx',
            SubtaskOwnerList:[],
            TaskList:[],
            TSList:[],
            tasks:[],
            tkName:null,
            tkStartDate:null,
            tkEndDate:null,
            tkType:null,
            tkOwner:null,
            modelSearch:false,
            currentPage: 1,
            totalCount: 0,
            pageSize: 5,
            tsType:'inputFalse',
            showLeave:true,
            TaskTypeList:[],
            StatusList:[
              { value: 'ToDelivered',label: 'Waiting for Delivery'},
              { value: 'Delivered',label: 'Delivering'},
              { value: 'DeliveryCompleted',label: 'Fully Delivered'},
            ],
            IsStationinList:[
              { value: 'Yes',label: 'Yes'},
              { value: 'No',label: 'No'},
            ],
            groupData: [],
            rules: {
              taskName: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              subtaskName: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              quantityMark: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              actualDeliveryEngineer: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              groupId: [
                { required: false, message:'Please select data', trigger: 'change' },
              ],
              subtaskStatus: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              plannedLabourHour: [
                { required: true, message:'Please input value', trigger: 'blur' },
                { validator: checkHours, trigger: 'blur' }
              ],
              subtaskEstimatedStartDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              subtaskEstimatedEndDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              serviceStartDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              serviceEndDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              plannedDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
              deliveryFinishedDate: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
            }
          }
        },
        methods:{
          getGroupList(){
            let url = `${this.$store.state.islhurl}getGroupList/999/1`
            let pm = {
              delStatus: 0, 
              islhToken: sessionStorage.getItem('islhtoken')
            }
            this._post(url,pm).then(
              res =>{
                this.groupData = res.data;
              }
            )
          },
          changeIsEngineerGroup(value) {
            if (value === 0) {
              this.subtaskForm.groupId = null;  // 清空 Group  
              this.rules.groupId[0].required = false;
              this.rules.actualDeliveryEngineer[0].required = true;
            } else if (value === 1) {
              this.subtaskForm.actualDeliveryEngineer = [];  // 清空 Engineer
              this.rules.groupId[0].required = true;
              this.rules.actualDeliveryEngineer[0].required = false;
            }
          },
          getTaskTypeList(){
            let url = `${this.$store.state.islhurl}keyValue/getSelectData`
            let pm = {
              sysKey: 'TaskType',
              delFlg: '0',
            }
            this._post(url,pm).then(
              res =>{
                this.TaskTypeList = res.data;
              }
            )
          },
          getTaskList(){
            let pm = {};
            let url =`${this.$store.state.islhurl}task/getUserTaskList/${this.pageSize}/${this.currentPage}`;
            let tkNumber = this.$route.params.taskNumber;
            if(tkNumber != undefined && tkNumber != null && tkNumber != ''){
              pm = {
                taskNumber: tkNumber,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
            }else{
              pm = {
                taskName: this.tkName==''?null:this.tkName,
                taskStartDate: this.tkStartDate==''?null:this.tkStartDate,
                taskEndDate: this.tkEndDate==''?null:this.tkEndDate,
                taskType: this.tkType==''?null:this.tkType,
                taskOwner: this.tkOwner==''?null:this.tkOwner,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
            }
            this._post(url,pm).then(
              res => {   
                this.TSList = res.data;
                this.tasks = res.data;
                this.totalCount = res.totalNums;
                let tkNumber = this.$route.params.taskNumber;
                if(tkNumber != undefined && tkNumber != null && tkNumber != ''){
                  this.subtaskForm.taskId = tkNumber;
                  this.selectTaskName(tkNumber);
                  this.editDis = 1;
                }
                let addFlag = this.$route.params.addFlag;
                if(addFlag == "Clone"){
                  this.cloneSubtask();
                }
              }
            )
          },
          searchTaskList(){
            this.pageSize = 5;
            this.currentPage = 1;
            let url =`${this.$store.state.islhurl}task/getUserTaskList/${this.pageSize}/${this.currentPage}`;
            let pm = {
              taskName: this.tkName==''?null:this.tkName,
              taskStartDate: this.tkStartDate==''?null:this.tkStartDate,
              taskEndDate: this.tkEndDate==''?null:this.tkEndDate,
              taskType: this.tkType==''?null:this.tkType,
              taskOwner: this.tkOwner==''?null:this.tkOwner,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res => {   
                this.TSList = res.data;
                this.totalCount = res.totalNums;
              }
            )
          },
          selectTask(){
            this.tkName = null;
            this.tkStartDate = null;
            this.tkEndDate = null;
            this.tkType = null;
            this.tkOwner = null;
            this.TSList = this.tasks;
            this.modelSearch = true;
          },
          handleInfo(item){
            this.subtaskForm.taskId = item.taskNumber;
            this.selectTaskName(item.taskNumber);
            this.modelSearch = false;
          },
          selectTaskName(taskId){
            let taskInfo = this.TSList.find(item => {
              return item.taskNumber === taskId;
            })
            if(taskInfo != null){
              this.subtaskForm.projectId = taskInfo.projectId;
              this.subtaskForm.taskName = taskInfo.taskName;
              this.subtaskForm.taskType = taskInfo.taskType;
              this.subtaskForm.serviceStartDate = taskInfo.taskStartDate;
              this.subtaskForm.serviceEndDate = taskInfo.taskEndDate;
              this.subtaskForm.plannedLabourHour = taskInfo.planLabourHour;
              let tkTypes = this.TaskTypeList.find(item => {
                return item.sysValue === taskInfo.taskType;
              })
              if(tkTypes.sysDesc == 'PersonalLeave'){
                this.showLeave = false;
              }else{
                this.showLeave = true;
              }
            }
          },
          cloneSubtask(){
            let tsNumber = this.$route.params.taskId;
            let taType = this.$route.params.tsType;
            let tkTypes = this.TaskTypeList.find(item => {
              return item.sysDesc === taType;
            })
            this.subtaskForm.taskType = tkTypes.sysValue;
            if(taType == 'PersonalLeave'){
              this.showLeave = false;
            }else{
              this.showLeave = true;
            }
            this.subtaskForm.taskId = tsNumber;
            this.subtaskForm.taskName = this.$route.params.taskName;
            this.subtaskForm.projectId = this.$route.params.projectId;
            this.subtaskForm.actualDeliveryEngineer.push(this.$route.params.actualDeliveryEngineer);
            this.subtaskForm.quantityMark = this.$route.params.quantityMark || 0;
            this.subtaskForm.groupId = this.$route.params.groupId;
            this.subtaskForm.subtaskName = this.$route.params.subtaskName;
            this.subtaskForm.subtaskStatus = "Delivered";
            this.subtaskForm.serviceStartDate = this.$route.params.serviceStartDate;
            this.subtaskForm.serviceEndDate = this.$route.params.serviceEndDate;
            this.subtaskForm.deliveryEngineerCity = this.$route.params.deliveryEngineerCity;
            this.subtaskForm.deliveryAddress = this.$route.params.deliveryAddress;
            this.subtaskForm.plannedLabourHour = this.$route.params.plannedLabourHour;
            this.subtaskForm.isStationin = this.$route.params.isStationin;
          },
          submitForm(formName) {
            this.$refs[formName].validate((pvalid) => {
              if (pvalid) {
                console.log('success submit')
                this.addInfo();
              } else {
                console.log('error submit!!');
                return false;
              } 
            });
          },
          addInfo(){
            if(this.reportArr != null && this.reportArr.length > 0){
              let attachmentArr = [];
              this.reportArr.forEach(item => {
                attachmentArr.push(item.aid);
              });
              this.subtaskForm.subtaskReport = attachmentArr.join(",");
            }
            this.subtaskForm.actualDeliveryEngineer = this.subtaskForm.actualDeliveryEngineer ? this.subtaskForm.actualDeliveryEngineer.join(",") : '';
            let params = {
              subtask:this.subtaskForm,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            // console.log(params);
            let url = `${this.$store.state.islhurl}subtask/addInfo`
            this._post(url,params).then(
              res => {
                if(res.code == 200){
                  // this.$router.push({path:'/subtask/list'})
                  let pm = { toSubtask: 'N' };
                  this.$router.push({ name:'subtask', params:pm });
                  this.$Message.success('Save successful' )
                }else{
                  this.$message({
                    type:'error',
                    showClose:true,
                    duration:10000,
                    message:res.message || 'Save failed'
                  });
                }
              }
            )
          },
          copySubtask(){
            this.subForm = {
              projectId:this.subtaskForm.projectId, taskId:this.subtaskForm.taskId, taskName:this.subtaskForm.taskName, taskType:this.subtaskForm.taskType, 
              subtaskName:this.subtaskForm.subtaskName, subtaskStatus:this.subtaskForm.subtaskStatus, plannedLabourHour:this.subtaskForm.plannedLabourHour, 
              serviceStartDate:this.subtaskForm.serviceStartDate, serviceEndDate:this.subtaskForm.serviceEndDate, deliveryEngineerCity:this.subtaskForm.deliveryEngineerCity,
              deliveryAddress:this.subtaskForm.deliveryAddress, isStationin:this.subtaskForm.isStationin
            };
          },
          continueForm(formName) {
            this.$refs[formName].validate((pvalid) => {
              if (pvalid) {
                console.log('success submit')
                this.continueAddInfo();
                this.copySubtask();
              } else {
                console.log('error submit!!');
                return false;
              } 
            });
          },
          continueAddInfo(){
            if(this.reportArr != null && this.reportArr.length > 0){
              let attachmentArr = [];
              this.reportArr.forEach(item => {
                attachmentArr.push(item.aid);
              });
              this.subtaskForm.subtaskReport = attachmentArr.join(",");
            }
            this.subtaskForm.actualDeliveryEngineer = this.subtaskForm.actualDeliveryEngineer.join(",");
            let params = {
              subtask:this.subtaskForm,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            // console.log(params);
            let url = `${this.$store.state.islhurl}subtask/addInfo`
            this._post(url,params).then(
              res => {
                if(res.code == 200){
                  // this.subtaskForm.actualDeliveryEngineer = [];
                  this.$refs.subtaskForm.resetFields();
                  this.subtaskForm = this.subForm;
                  // this.SubtaskOwnerList = this.UserList;
                  this.$message({
                    type:'success',
                    showClose:true,
                    duration:5000,
                    message:'Save successful'
                  });
                }else{
                  this.$message({
                    type:'error',
                    showClose:true,
                    duration:10000,
                    message:res.message || 'Save failed'
                  });
                }
              }
            )
          },
          beforeUpload(file){
            this.downloadLoading = this.$loading({
              lock:true,
              text:'Data is importing...',
              spinner:'el-icon-loading',
              background:'rgba(0,0,0,0.7)'
            });
            let fd = new FormData();
            fd.append('fileInput',file);
            fd.append('source',"Subtask");
            fd.append('islhToken',sessionStorage.getItem("islhtoken"));
            let url = `${this.$store.state.islhurl}upload`
            this._post(url,fd).then(
              res =>{
                this.downloadLoading.close();
                if(res.code == '200'){
                  this.fileList.push({name: res.fileName, url: res.fileAliasName});
                  this.reportArr.push({aid: res.attachmentId, fileurl: res.fileAliasName});
                  this.$message.success('File import successful！');
                }else{
                  this.$message({type:'error', showClose:true, duration:10000, message:res});
                }
              }
            ).catch(error=> {
              this.downloadLoading.close();
              this.$message({type:'error', showClose:true, duration:10000, message:'Operation failed！error:'+error});
            })
          },
          handlePreview(file){
            let url =`${this.$store.state.islhurl}download?fileAliasName=${file.url}&fileName=${file.name}`
            window.open(url);
          },
          handleRemove(file){
            if (file && file.status === "success") {
              let attachmentId = null;
              this.reportArr.forEach(item => {
                if (item.fileurl === file.url) {
                  attachmentId = item.aid;
                  this.reportArr.splice(item, 1);
                }
              });
              let params = {
                id: attachmentId,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
              let url =`${this.$store.state.islhurl}attachment/deleteInfo`;
              this._post(url, params).then(
                res => {
                  this.fileList.forEach(item => {
                    if (item.url === file.url) {
                      this.fileList.splice(item, 1);
                    }
                  });
                }
              )
            }
          },
          returnList(){
            this.$router.push({path:'/subtask/list'})
          },
          changePage (val) {
            this.currentPage = val;
            this.getTaskList();
          },
          changePageSize (val) {
            this.pageSize = val;
            this.getTaskList();
          },
          loadMore(n) {
            // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
            // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
            return () => (this.rangeNumber += 5); // 每次滚动到底部可以新增条数,可自定义
          },
          //远程搜索方法
          remoteMethod(query) {
            if (query !== '') {
              // 清除之前的定时器
              if (this.timeout) {
                clearTimeout(this.timeout)
              }
              // 防抖处理，300ms后执行
              this.timeout = setTimeout(() => {
                this.fetchUserOptions(query)
              }, 200)
            } else {
              this.SubtaskOwnerList = [];
            }
          },
          fetchUserOptions(query) {
            let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
            this._get(url).then().then(res => {
              if(res.code === 200 && res.data) {
                this.SubtaskOwnerList = res.data;
              } else {
                this.SubtaskOwnerList = [];
              }
            }).catch(error => {
              this.SubtaskOwnerList = [];
              console.error('搜索失败:', error)
            })
          },
        },
        directives:{
          'el-select-loadmore':(el, binding) => {
            // 获取element-ui定义好的scroll盒子
            const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
            if(SELECTWRAP_DOM){
              //解除绑定事件
              el.unbindEventListener = () => {
                SELECTWRAP_DOM.removeEventListener("scroll", function () {
                  const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                  if (condition) binding.value();
                });
              }
              //绑定事件
              SELECTWRAP_DOM.addEventListener("scroll", function () {
                /**
                 * scrollHeight 获取元素内容高度(只读)
                 * scrollTop 获取或者设置元素的偏移值,
                 *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
                 * clientHeight 读取元素的可见高度(只读)
                 * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
                 * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
                 */
                const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                if (condition) binding.value();
              });
            }
          },
        }
    }	
</script>


// WEBPACK FOOTER //
// src/view/subtask/subtaskAdd.vue